import { Popover, SegmentedControl, Table } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { useEffect, useState } from 'react';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../../commons/functions';
import { useGlobalState } from '../../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../../layout';
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { mdiChatOutline } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import Favorites from '../../../../../../components/extras/Favorites';
import MPModal from '../../../../../../components/MPModal';
import { fetchWithWatch } from '../../../../../../hooks/fetchWithWatch';
const _preserve = React.version;

export const OPSFuelTanksMeasurePage = () => {
    const { menu, parameters, data } = useGlobalState();

    const [type, setType] = useState("");




    const [measures, setMeasures] = useState<any[]>([]);




    useEffect(() => {
        handleCheckFuel();
    }, [type, parameters.month]);
    const handleCheckFuel = async () => {
        if (parameters && parameters.month && type !== "") {
            try {
                setLoading(true)
                setMeasures([])
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/movements/tanks/measure',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        tank: type,
                        month: parameters.month,
                        year: parameters.year,
                        orderBy: "dateMeasure",
                        order: "desc"
                    }),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    setMeasures(data.measures);
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }
        }
    }

    //
    return (
        <CustomAppLayout
            toolsHide
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header actions={<Favorites />}
                            description={"Cartola de mediciones de estanques"}
                        >
                            Mediciones
                        </Header>
                        <SpaceBetween direction='vertical' size='xs'>

                            {!!measures && (
                                <Table
                                    variant="borderless"
                                    empty={"Sin mediciones en el periodo seleccionado"}
                                    header={

                                        <SpaceBetween direction="horizontal" size="xs">
                                            <SegmentedControl
                                                selectedId={type}
                                                onChange={({ detail }) => {
                                                    setType(detail.selectedId)
                                                }}
                                                label="Tipo combustible"
                                                options={[
                                                    { text: "AVGAS", id: "AVGAS" },
                                                    { text: "JP1", id: "JP1" },
                                                ]}
                                            />
                                            <MPModal
                                                width={120}
                                                today prevMonth nextMonth end={new Date()}
                                                date={`${parameters.year}-${parameters.month}`}
                                                onConfirm={(date) => {
                                                    setParameters({ ...parameters, month: date.month, year: date.year });
                                                }}
                                            />
                                        </SpaceBetween>
                                    }
                                    items={measures}
                                    columnDefinitions={[
                                        {
                                            id: "date",
                                            header: "Fecha",
                                            cell: item => item.dateMeasure,
                                            width: 120

                                        },
                                        {
                                            id: "measureType",
                                            header: "Tipo",
                                            cell: item =>
                                                <SpaceBetween direction="horizontal" size="xs">
                                                    {item.measureType === "LOAD" ? "Carga" : "Medición"}
                                                    {item.obs && item.obs.toString().trim() !== "" && (
                                                        <Popover triggerType="custom" header='Observaciones' content={item.obs || "Sin observaciones"}>
                                                            <Icon path={mdiChatOutline} size={0.75} />
                                                        </Popover>
                                                    )}
                                                </SpaceBetween>
                                            ,
                                            width: 120

                                        },
                                        {
                                            id: "liters",
                                            header: "Litros",
                                            cell: item => item.liters.toString(),
                                            width: 120

                                        },
                                        {
                                            id: "receipt",
                                            header: "Folio",
                                            cell: item => item.receipt.toString(),
                                            width: 120

                                        },
                                    ]}
                                />

                            )}
                        </SpaceBetween>
                    </SpaceBetween>


                </>
            } />
    );
};
